export default __webpack_public_path__ + "static/O0129-d9ca751381bf4e2c7c09b5daddbe0b61.png";